/**
 * Class representing a validator for question part marks.
 * This class ensures that the marks for a question part are valid.
 */
class QuestionPartMarksValidator {
    /**
     * Creates an instance of QuestionPartMarksValidator.
     * @param {Object} model - The model containing the question part data.
     * @param {Object} $injector - The AngularJS injector service.
     */
    constructor(model, $injector) {
        this.model = model;
        this.$injector = $injector;
        this._translate = null;
        this._messageTranslateString = 'CMS.FACTORIES.MODELS.VALIDATORS.LOGIC.QP-MARKS';
        this._message = null;
        this._forced_check = true;
    }

    /**
     * Getter for the $translate service.
     * Lazily initializes the $translate service using the $injector.
     * @returns {Object} The $translate service.
     */
    get $translate() {
        if (!this._translate) {
            this._translate = this.$injector.get('$translate');
        }
        return this._translate;
    }

    /**
     * Validates the question part marks.
     * @param {Object} from - The source object triggering the validation.
     * @returns {Object} The validation result.
     */
    validate(from) {
        let result = {};
        let error = false;

        // Check if the marks are less than or equal to zero
        if (this.model.getMarks() <= 0) {
            error = true;
        }

        result = {
            'onSheetBlur':      true,
            'onlyBanner':       false,
            'validator':        this.getValidatorName(),
            'modelUUID':        this.model.getUUID(),
            'error':            error,
            'status':           error ? 'DANGER' : 'SUCCESS',
            'message':          this.getErrorMessage(),
            'message_template': false,
            'callbacks':        []
        };

        return result;
    }

    /**
     * Gets the error message for invalid question part marks.
     * @returns {string} The error message.
     */
    getErrorMessage() {
        let questionHeadline = this.model.getQuestionHeadline();
        this._message = this.$translate.instant(this._messageTranslateString, {
            s: questionHeadline ? questionHeadline : ''
        });

        return this._message;
    }

    /**
     * Getter for the forced check flag.
     * @returns {boolean} The forced check flag.
     */
    get forcedCheck() {
        return this._forced_check;
    }

    /**
     * Gets the name of the validator.
     * @returns {string} The name of the validator.
     */
    getValidatorName() {
        return 'QuestionPartMarksValidator';
    }
}

export default QuestionPartMarksValidator;